import { Grid, Stack, Typography } from "@mui/material";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { CustomerDealingAndActiveInfo } from "pages/common/customer-dealing-and-active-info";
import { NumberText } from "share-components/atomics/number-text";
import { PropertyInfo } from "share-components/atomics/property-info";
import { WorkOrderPoStatus } from "../components/status";
import { roundTo } from "commons/ultilities";
export const WorkOrderInfo = observer(() => {
  const {
    workOrderPoManagement: { workOrderPoDetail },
  } = useStores();
  const customerDisplay = workOrderPoDetail?.customerDisplay;

  return (
    <Stack padding={1}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6">{`Thông Tin Đơn Hàng Và Lệnh Sản Xuất`}</Typography>
            {workOrderPoDetail?.statusId && workOrderPoDetail?.status && (
              <WorkOrderPoStatus
                status={workOrderPoDetail.status}
                isCompensating={workOrderPoDetail?.isCompensating ?? false}
              ></WorkOrderPoStatus>
            )}
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Tên Giao Dịch:"
            value={
              customerDisplay?.dealingName ? (
                <CustomerDealingAndActiveInfo
                  customer={customerDisplay}
                ></CustomerDealingAndActiveInfo>
              ) : (
                ""
              )
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Mã Hàng:"
            value={workOrderPoDetail?.purchaseOrderItem?.product?.code || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Tên Hàng:"
            value={workOrderPoDetail?.purchaseOrderItem?.product?.name || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Mã Vạch:"
            value={workOrderPoDetail?.purchaseOrderItem?.product?.barcode || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Ngày Đặt:"
            value={
              dateTimeDisplay(workOrderPoDetail?.purchaseOrder?.poDate) || ""
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số Đơn Hàng:"
            value={workOrderPoDetail?.purchaseOrder?.poNumber || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Ngày Ra Lệnh:"
            value={dateTimeDisplay(workOrderPoDetail?.date) || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Ngày Giao Hàng:"
            value={
              dateTimeDisplay(
                workOrderPoDetail?.purchaseOrderItem?.deliveryDate,
              ) || ""
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số Lệnh S/X:"
            value={workOrderPoDetail?.woNumber || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="S/L Giao:"
            value={
              <NumberText
                value={
                  workOrderPoDetail?.purchaseOrderItem?.quantityStandard || 0
                }
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số Lô S/X:"
            value={workOrderPoDetail?.woBatchNumber || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="S/L Trên:"
            value={
              <NumberText
                value={workOrderPoDetail?.purchaseOrderItem?.quantityUpper || 0}
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số Lượng S/X:"
            value={
              <NumberText
                value={workOrderPoDetail?.productionAmount || 0}
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="S/L Dưới:"
            value={
              <NumberText
                value={workOrderPoDetail?.purchaseOrderItem?.quantityLower || 0}
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <PropertyInfo
            title="Ghi chú:"
            value={workOrderPoDetail?.note || ""}
          ></PropertyInfo>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ marginTop: "16px" }}>
        <Grid item xs={12}>
          <Typography variant="h6">{`Công Đoạn Xuất Vật Tư Giấy`}</Typography>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="S/L Sản Xuất:"
            value={
              <NumberText
                value={workOrderPoDetail?.poItemProductionAmount || 0}
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="T/L Giấy:"
            value={
              <NumberText
                value={roundTo(workOrderPoDetail?.totalPaperWeight || 0, 2)}
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Loại Giấy:"
            value={
              workOrderPoDetail?.purchaseOrderItem?.product?.material
                ?.paperType || ""
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Định Lượng:"
            value={
              <NumberText
                value={
                  workOrderPoDetail?.purchaseOrderItem?.product?.material
                    ?.gsmStandard || 0
                }
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Hiệu Giấy:"
            value={
              workOrderPoDetail?.purchaseOrderItem?.product?.material
                ?.paperBrand || ""
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Khổ Giấy 1:"
            value={
              <NumberText
                value={
                  workOrderPoDetail?.purchaseOrderItem?.product?.process
                    ?.firstFullPaperSize || 0
                }
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Chiều Dài:"
            value={
              <NumberText
                value={
                  workOrderPoDetail?.purchaseOrderItem?.product?.process
                    ?.firstFullPaperLength || 0
                }
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="S/L Tờ:"
            value={
              <NumberText
                value={workOrderPoDetail?.poItemFirstFullPaperAmount || 0}
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Khổ Giấy 2:"
            value={
              <NumberText
                value={
                  workOrderPoDetail?.purchaseOrderItem?.product?.process
                    ?.secondFullPaperSize || 0
                }
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Chiều Dài:"
            value={
              <NumberText
                value={
                  workOrderPoDetail?.purchaseOrderItem?.product?.process
                    ?.secondFullPaperLength || 0
                }
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="S/L Tờ:"
            value={
              <NumberText
                value={workOrderPoDetail?.poItemSecondFullPaperAmount || 0}
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Khổ Giấy In 1:"
            value={
              <NumberText
                value={
                  workOrderPoDetail?.purchaseOrderItem?.product?.process
                    ?.printPaperSize || 0
                }
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Chiều Dài:"
            value={
              <NumberText
                value={
                  workOrderPoDetail?.purchaseOrderItem?.product?.process
                    ?.printPaperLength || 0
                }
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="S/L Tờ:"
            value={
              <NumberText
                value={workOrderPoDetail?.poItemFirstPrintPaperAmount || 0}
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Khổ Giấy In 2:"
            value={
              <NumberText
                value={
                  workOrderPoDetail?.purchaseOrderItem?.product?.process
                    ?.secondPrintPaperSize || 0
                }
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Chiều Dài:"
            value={
              <NumberText
                value={
                  workOrderPoDetail?.purchaseOrderItem?.product?.process
                    ?.secondPrintPaperLength || 0
                }
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="S/L Tờ:"
            value={
              <NumberText
                value={workOrderPoDetail?.poItemSecondPrintPaperAmount || 0}
              ></NumberText>
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <PropertyInfo
            title="Ghi chú:"
            value={workOrderPoDetail?.poItemNote || ""}
          ></PropertyInfo>
        </Grid>
      </Grid>
    </Stack>
  );
});
